export default {
  name: "QuickActions",

  data() {
    return ({
      hover: null,
      action_items: [
        {
          label: "Create Report",
          icon: "bi bi-bar-chart-fill",
          color_class: "qa-warning",
          meta: "Reports"
        },
        {
          label: "Log Maintenance",
          icon: "bi bi-wrench-adjustable",
          color_class: "qa-info",
          meta: "Maintenance"
        },
        {
          label: "Security Alert",
          icon: "bi bi-shield-check",
          color_class: "qa-success",
          meta: "Security"
        }
      ],
    });
  },
};
